import { StatsCard } from "@tfg/ui"
import { Link } from "react-router-dom"

export type SpotlightBoxProps = {
  targetUrl: string
  description: string
  count: number
}

export const SpotlightBox = ({
  targetUrl,
  description,
  count,
}: SpotlightBoxProps) => {
  return (
    <Link to={targetUrl} target="_blank">
      <StatsCard
        description={description}
        mih="9rem"
        h="100%"
        value={`${count}`}
      />
    </Link>
  )
}
